interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const TabButton = ({ active, onClick, children }: TabButtonProps) => (
  <button
    onClick={onClick}
    style={{
      padding: '10px 20px',
      background: active ? '#0a104f' : 'transparent',
      color: active ? 'white' : '#6b7280',
      border: 'none',
      borderBottom: active ? '2px solid #0a104f' : '2px solid transparent',
      cursor: 'pointer',
      fontWeight: active ? '600' : '400',
      fontSize: '14px',
      transition: 'all 0.2s',
      marginBottom: '-2px',
    }}
  >
    {children}
  </button>
);

export default TabButton;
